// extracted by mini-css-extract-plugin
export default {"leftContainer":"StudentPage_leftContainer__1XlVe","rightContainer":"StudentPage_rightContainer__22umP"};